import {
  REQUEST_PERMISSIONS,
  REQUEST_USER,
  LOAD_PERMISSIONS_STARTED,
  LOAD_PERMISSIONS_COMPLETED,
  LOAD_PERMISSIONS_FAILED,
  LOAD_USER_STARTED,
  LOAD_USER_COMPLETED,
  LOAD_USER_FAILED,
} from "./types"

export const requestPermissions = () => ({
  type: REQUEST_PERMISSIONS,
})

export const requestUser = () => ({
  type: REQUEST_USER,
})

export const loadPermissionsStarted = () => ({
  type: LOAD_PERMISSIONS_STARTED,
})

export const loadPermissionsCompleted = permissions => ({
  type: LOAD_PERMISSIONS_COMPLETED,
  payload: {
    permissions,
  },
})

export const loadPermissionsFailed = () => ({
  type: LOAD_PERMISSIONS_FAILED,
})

export const loadUserStarted = () => ({
  type: LOAD_USER_STARTED,
})

export const loadUserCompleted = user => ({
  type: LOAD_USER_COMPLETED,
  payload: {
    roles: user.roles,
    user,
  },
})
export const loadUserFailed = () => ({
  type: LOAD_USER_FAILED,
})
